import { CoverageTypeEnumSimple } from '@global/infrastructure/enums/coverage-type.enum';
import {
  YOUR_CAR_PERM,
  YOUR_CAR_TEMP,
  YOUR_DETAILS,
  YOUR_DRIVERS_PERM,
  YOUR_DRIVERS_TEMP,
  YOUR_ADDRESS,
  YOUR_ADDRESSES,
  YOUR_REGISTRATION,
  ALLOCATE,
  PREMIUM,
  REVIEW_FULL,
  REVIEW_FULL_ROUTE,
  REVIEW_DIRECT_DEBIT,
  REVIEW_DIRECT_DEBIT_ROUTE,
  CONFIRM_FULL,
  CONFIRM_FULL_ROUTE,
  CONFIRM_DIRECT_DEBIT,
  CONFIRM_DIRECT_DEBIT_ROUTE,
  CONFRIM_RENEWAL_TYPE,
  CONFRIM_RENEWAL_TYPE_ROUTE,
  ERRORS,
  REFUND,
  PAYMENT_DIRECT_DEBIT_DISPLAY,
  PAYMENT_DIRECT_DEBIT_DISPLAY_ROUTE,
  PAYMENT_DIRECT_DEBIT_EDIT,
  PAYMENT_DIRECT_DEBIT_EDIT_ROUTE,
  PREFERRED_PAYMENT_DATE,
  PREFERRED_PAYMENT_DATE_ROUTE,
  PAYMENT_CREDIT_CARD,
  PAYMENT_CREDIT_CARD_ROUTE,
  DASHBOARD_SELECT,
  DASHBOARD_UPDATE,
  RENEWAL_PREFERENCE,
  YOUR_MILEAGE,
  YOUR_CONVICTIONS,
  YOUR_TEMPORARY_EUROPEAN_COVER,
  YOUR_VEHICLE_USAGE,
  WHERE_IPARK_MY_CAR,
  PARKING_DETAILS,
  YOUR_POSTAL_ADDRESS,
  YOUR_DRIVERS_MORE_INFO,
  MANAGE_DRIVER_INFORMATION,
  CHANGE_TYPE,
  CHANGE_DATE,
  YOUR_DRIVING_HISTORY,
  YOUR_LICENCE_NUMBER,
  CHOOSE_MAIN_DRIVERS_ROUTE,
  CHOOSE_MAIN_DRIVER
} from '@app/infrastructure/constants';
import { coverageTypeMap, coverageTypeToNamesMap } from '@global/infrastructure/constants/premium';
import { JourneyFeatures } from '@app/infrastructure/data/journey-features';
import { environment } from '@env/environment';

export class CustomUtility {

  private static readonly featuresMap = new Map<string, string>([
    ['changeType', CHANGE_TYPE],
    ['changeDate', CHANGE_DATE],
    ['dashboardSelect', DASHBOARD_SELECT],
    ['dashboardUpdate', DASHBOARD_UPDATE],
    ['renewalPreference', RENEWAL_PREFERENCE],
    ['yourCarPerm', YOUR_CAR_PERM],
    ['yourCarTemp', YOUR_CAR_TEMP],
    ['yourMileage', YOUR_MILEAGE],
    ['yourRegistration', YOUR_REGISTRATION],
    ['yourDetails', YOUR_DETAILS],
    ['yourAddresses', YOUR_ADDRESSES],
    ['yourAddress', YOUR_ADDRESS],
    ['yourPostalAddress', YOUR_POSTAL_ADDRESS],
    ['yourDriversPerm', YOUR_DRIVERS_PERM],
    ['yourDriversTemp', YOUR_DRIVERS_TEMP],
    ['yourDriversMoreInfo', YOUR_DRIVERS_MORE_INFO],
    ['yourConvictions', YOUR_CONVICTIONS],
    ['yourTemporaryEuropeanCover', YOUR_TEMPORARY_EUROPEAN_COVER],
    ['yourVehicleUsage',  YOUR_VEHICLE_USAGE],
    ['whereIparkMyCar',  WHERE_IPARK_MY_CAR],
    ['parkingDetails', PARKING_DETAILS],
    ['yourDriversDetails', MANAGE_DRIVER_INFORMATION],
    ['yourDrivingHistory', YOUR_DRIVING_HISTORY],
    ['yourLicenceNumber', YOUR_LICENCE_NUMBER],
    [CHOOSE_MAIN_DRIVER, CHOOSE_MAIN_DRIVERS_ROUTE],
    [ALLOCATE, ALLOCATE],
    [PREMIUM, PREMIUM],
    [REVIEW_FULL, REVIEW_FULL_ROUTE],
    [REVIEW_DIRECT_DEBIT, REVIEW_DIRECT_DEBIT_ROUTE],
    [PAYMENT_DIRECT_DEBIT_DISPLAY, PAYMENT_DIRECT_DEBIT_DISPLAY_ROUTE],
    [PAYMENT_DIRECT_DEBIT_EDIT, PAYMENT_DIRECT_DEBIT_EDIT_ROUTE],
    [PREFERRED_PAYMENT_DATE, PREFERRED_PAYMENT_DATE_ROUTE],
    [JourneyFeatures.directDebitNew.name, `/payment/${JourneyFeatures.directDebitNew.path}`],
    [JourneyFeatures.directDebitReview.name, `/payment/${JourneyFeatures.directDebitReview.path}`],
    [PAYMENT_CREDIT_CARD, PAYMENT_CREDIT_CARD_ROUTE],
    [REFUND, REFUND],
    [CONFIRM_FULL, CONFIRM_FULL_ROUTE],
    [CONFIRM_DIRECT_DEBIT, CONFIRM_DIRECT_DEBIT_ROUTE],
    [CONFRIM_RENEWAL_TYPE, CONFRIM_RENEWAL_TYPE_ROUTE],
    [ERRORS, ERRORS]
  ]);

  static lookupFeature = (featureName: string) => CustomUtility.lookupByKeyFromMapper(CustomUtility.featuresMap, featureName);

  static lookupCoverageType = (coverType: string) => CustomUtility.lookupByKeyFromMapper(coverageTypeMap, coverType);

  static lookupCoverageTypeToName = (coverType: CoverageTypeEnumSimple) => CustomUtility.lookupByKeyFromMapper(coverageTypeToNamesMap, coverType);

  static redirectToExternalUrl(url: string) {
    const isApp = localStorage.getItem('isApp');
    if (isApp === 'true') {
      localStorage.setItem('isApp', 'false');
      window.location.href = `app.${environment?.brand_copy.brandSimple}.com://landing`;
    } else {
      const baseUrl = location.origin || `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}`;
      window.location.href = `${baseUrl}${url}`;
    }
  }

  private static lookupByKeyFromMapper<K, V>(mapper: Map<K, V>, key: K): V {
    return mapper.get(key) || null;
  }

  static isEmpty(obj: any): boolean {
    if (!obj) {
      return true;
    }
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }
}
